/* eslint-disable react-hooks/exhaustive-deps */

import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";
import { useMemo } from "react";

import { useGetUnverifiedResellers } from "../apis";

const useInventoryManagersList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      search: debouncedSearch,
      orderBy: sorting[0]?.id ?? null,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
    }),
    [page, debouncedSearch, sorting]
  );

  const {
    unverifiedResellers,
    meta,
    isLoading,
    refetch: refetchUnverifiedResellers
  } = useGetUnverifiedResellers(requestParams);

  return {
    unverifiedResellers,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchUnverifiedResellers
  };
};

export default useInventoryManagersList;
